import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

/** Store list is the site root. A smart-basket invite continues on /shop. */
export const homeEntryGuard: CanActivateFn = (route) => {
  if (isStoreListShare(route) || !isSmartShare(route)) return true;
  return inject(Router).createUrlTree(['/shop'], { queryParams: route.queryParams });
};

function isStoreListShare(route: ActivatedRouteSnapshot): boolean {
  return route.queryParamMap.get('page') === 'store-list' || pending('commpare_pending_share_page') === 'store-list';
}

function isSmartShare(route: ActivatedRouteSnapshot): boolean {
  const tab = route.queryParamMap.get('tab');
  const login = route.queryParamMap.get('login');
  return (
    tab === 'cart' ||
    tab === 'list' ||
    !!route.queryParamMap.get('joinToken') ||
    !!route.queryParamMap.get('basketId') ||
    login === '1' ||
    login === 'true' ||
    !!pending('commpare_pending_join_token') ||
    !!pending('commpare_pending_basket_id')
  );
}

function pending(key: string): string | null {
  try {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  } catch {
    return null;
  }
}
